<template>
  <div class="Tian_main">
    <div class="pos_all">
      <div class="all_nav">
        <p>FS预售大促期间完成率 By Store</p>
        <span></span>
      </div>
      <PosTable></PosTable>
    </div>
    <div class="pos_all">
      <div class="all_nav">
        <p>FS By Store UV & ePOS大促期间趋势</p>
        <div>
          <span>{{startTime }}</span>
        </div>
      </div>
      <div class="tian_uvall">
        <div class="tian_uv">
          <div class="uvlogo">
            <img src="../../assets/jpg/UV总额.svg" alt />
          </div>
          <div class="uvtit">
            <p>UV总额 (K)</p>
            <span>{{this.Uvalue|NumFormat}}</span>
            <p>{{`VS.LYTD ${this.uvRate}`}}</p>
            <p class="kong"></p>
          </div>
        </div>
        <div class="tian_uv">
          <div class="uvlogo">
            <img src="../../assets/jpg/销售总额.svg" alt />
          </div>
          <div class="uvtit">
            <p>销售总额 (RMB`000)</p>
            <span>{{this.SaleValue|NumFormat}}</span>
            <p>{{`VS.LYTD ${this.lyRate==''?"0%":this.lyRate}`}}</p>
            <p>{{`VS.TARGET ${this.vstarget==''?"0%":this.vstarget}`}}</p>
          </div>
        </div>
      </div>
      <div class="charts">
        <Tiancharts @senDshopNm="getTmallSumData"></Tiancharts>
      </div>
    </div>
  </div>
</template>
<script>
import PosTable from "@/components/TianMao/Tian_tableList";
import Tiancharts from "@/components/TianMao/Tiancharts";
import qs from "qs";

export default {
  name: "TianMao",
  data() {
    return {
      Uvalue: 0,
      SaleValue: 0,
      startTime: "",
      endTime: "",
      shopNm: "",
      uvRate: 0,
      lyRate: 0,
      vstarget: 0
    };
  },
  mounted() {},
  methods: {
    getTmallSumData(value) {
      this.shopNm = value;
      this.Uvalue = 0;
      this.SaleValue = 0;
      this.uvRate = 0;
      this.lyRate = 0;
      this.vstarget = 0;
      this.$addr
        .post(
          `Sales/getTmallSumData`,
          qs.stringify({ type: 1, shopNm: value == 1 ? null : value })
        )
        .then(res => {
          console.log(res)
          this.Uvalue = res.data.data[0].uv;
          this.SaleValue = res.data.data[0].salesValue;
          this.uvRate = res.data.data[0].uvRate;
          this.lyRate = res.data.data[0].ly;
          this.vstarget = res.data.data[0].achieving;
        })
        .catch(error => {
          // this.$toast('接受数据失败');
        });
    },
    getUpdateTime() {
      this.$addr
        .post("Sales/getUpdateDate")
        .then(res => {
           var time4 = new Date((res.data.data[0].versionUpdateDate.time));
          var y4 = time4.getFullYear();
          var m4 = (time4.getMonth()+1).toString().padStart(2,0);
          var d4 = (time4.getDate()).toString().padStart(2,0);
          this.startTime =`${y4}-${m4}-${d4}`
        })
        .catch(error => {
          // this.$toast('接受数据失败');
        });
    }
  },
  components: {
    PosTable,
    Tiancharts
  },
  created() {
    this.getTmallSumData(), this.getUpdateTime();
  }
};
</script>
<style  scoped>
.kong {
  line-height: 18px;
  height: 18px;
}
.Tian_main {
  position: relative;
  top: -15px;
  left: 0;
  min-height: 740px;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  overflow: hidden;
}
.Tian_main .all_nav,
.Tian_main .Tmall_nav,
.Tian_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #d1534b;
  border-radius: 22.5008px;
  height: 35px;
  margin: 28.8px 20px 20px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Tian_main .all_nav {
  margin-bottom: 15px;
}
.Tian_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "PingFangSC-Medium";
  font-size: 16px;
  color: #ffffff;
}

.Tian_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  margin-right: 15px;
  opacity: 0.6;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
}
.Tian_main .pos_all {
  min-height: 264px;
  width: 100%;
  margin: 0 auto;
}
.pos_Tmall {
  overflow: hidden;
}
.Full_stage {
  overflow: hidden;
}

.tian_uvall {
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;
  padding: 0 2.9% 0 0;
}
.tian_uv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.uvtit {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.uvtit p {
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #191919;
  line-height: 18px;
  margin-bottom: 10px;
}
.uvtit span {
  opacity: 0.91;
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #282828;
  margin-bottom: 10px;
}
.uvlogo {
  margin: 25px 10px 20px 26px;
}
.uvlogo img {
  margin: -20px 10px 0 -20px;
}
.charts {
  min-height: 350px;
  padding: 0 16.5px;
  position: relative;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/TianMao/Tian.vue